import { useLanguage } from "@/contexts/LanguageContext";

const BattleSection = () => {
  const { t } = useLanguage();

  const rows = [
  "interest",
  "priceEval",
  "goalNeg",
  "legalCheck",
  "pricing"] as
  const;

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground text-center mb-16">
          {t.battle.title}
        </h2>

        <div className="max-w-4xl mx-auto rounded-2xl border border-border bg-card shadow-lg overflow-x-auto">
          {/* Table header */}
          <div className="grid grid-cols-3 border-b border-border bg-muted/40 min-w-[480px]">
            <div className="p-3 md:p-6" />
            <div className="p-3 md:p-6 text-center border-l border-border">
              <span className="font-semibold text-muted-foreground text-sm md:text-base">{t.battle.broker}</span>
            </div>
            <div className="p-3 md:p-6 text-center border-l border-primary/30 bg-primary/5">
              <span className="font-bold text-primary text-sm md:text-base">{t.battle.dealigator}</span>
            </div>
          </div>

          {/* Table rows */}
          {rows.map((key, i) => {
            const item = t.battle[key];
            const isLast = i === rows.length - 1;
            return (
              <div
                key={key}
                className={`grid grid-cols-3 min-w-[480px] ${!isLast ? "border-b border-border" : ""} hover:bg-muted/20 transition-colors`}>

                <div className="p-3 md:p-6 flex items-center">
                  <span className="text-foreground text-sm md:text-lg font-semibold">{item.label}</span>
                </div>
                <div className="p-3 md:p-6 flex items-center justify-center border-l border-border">
                  <span className="text-xs md:text-base text-muted-foreground text-center">{item.broker}</span>
                </div>
                <div className="p-3 md:p-6 flex items-center justify-center border-l border-primary/30 bg-primary/5">
                  <span className="text-xs md:text-base font-semibold text-primary text-center">{item.ai}</span>
                </div>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default BattleSection;